module.exports = __webpack_public_path__ + "static/media/iframe_modal_close.6fd7e1ed.svg";